export default function debounce(func: Function, delay: number) {
    let timeout: NodeJS.Timeout | null = null
    return () => {
        if (timeout) clearTimeout(timeout)

        timeout = setTimeout(() => {
            func()
        }, delay)
    }
}
